import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import i18n from 'i18next';

const TITLES: any = {
	'my-investments': i18n.t('myInvestmentsText'),
	invest: i18n.t('investText'),
	register: i18n.t('registrationText'),
	overview: i18n.t('overviewText'),
	statement: i18n.t('statementText'),
	funding: `${i18n.t('depositText')} / ${i18n.t('withdrawText')}`,
	'settings/2fa': i18n.t('2FaAuthenticationText'),
	settings: i18n.t('settingsText'),
	login: i18n.t('loginText'),
	'recover-password': i18n.t('passwordResetText'),
	projects: i18n.t('investText'),
	residency: i18n.t('taxResidencyText'),
	'verify-your-identity': i18n.t('verificationText'),
	kyc: 'KYC',
	aml: 'AML',
	success: 'AML',
	news: i18n.t('allNewsText'),
	'': i18n.t('loginText'),
};

export const useDocumentTitle = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		const title = Object.keys(TITLES).find((item) => pathname.includes(item));

		document.title = typeof title === 'undefined' ? 'Crowdpear' : `Crowdpear: ${TITLES[title]}`;
	}, [pathname]);

	return null;
};
